// import React, { useState, useEffect, useCallback } from "react";
// import {
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     // Paper,
//     Pagination,
//     Card,
//     Button,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     TextField,
//     Switch,
//     CircularProgress,
//     Box,
//     Stack,
//     IconButton,
//     Modal,
//     // Typography,
// } from "@mui/material";
// import { MdEdit, MdVisibility } from "react-icons/md";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import debounce from "lodash.debounce";
// import EntitiesForm from "./ModelForm/EntitiesForm";
// import dayjs from "dayjs";

// const Entities = () => {
//     const navigate = useNavigate();
//     const [data, setData] = useState([]);
//     const [totalPages, setTotalPages] = useState(1);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [openModal, setOpenModal] = useState(false);
//     const [openModel2, setOpenModel2] = useState(false)
//     const [selectedItem, setSelectedItem] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [formData, setFormData] = useState({
//         code: "",
//         discount_type: "",
//         discount: "",
//         minimum_bill_amount: "",
//         is_live: true,
//     });

//     useEffect(() => {
//         fetchData(currentPage, searchQuery);
//     }, [currentPage, searchQuery]);

//     const fetchData = useCallback(
//         debounce(async (page, query) => {
//             setLoading(true);
//             try {
//                 const { data } = await axios.get(
//                     query ? `https://api.medstown.com/offer/entities?page=${page}&slug=${query}` :`https://api.medstown.com/offer/entities?page=${page}`
//                 );
//                 // console.log(data.data)
//                 setData(data?.data);
//                 setTotalPages(Math.ceil(data.data.totalPromocodes / 10));
//             } catch (error) {
//                 console.error("Error fetching data:", error);
//             } finally {
//                 setLoading(false);
//             }
//         }, 500),
//         []
//     );

//     useEffect(() => {
//         fetchData(currentPage, searchQuery);
//     }, [currentPage, searchQuery, fetchData]);
//     const handlePageChange = (event, value) => {
//         setCurrentPage(value);
//     };

//     const handleEdit = (item) => {
//         setSelectedItem(item);
//         setFormData({
//              title: item.title,
//             // discount_type: item.discount_type,
//             // discount: item.discount || item.fixedPrice, // Handle both types
//             // minimum_bill_amount: item.minimum_bill_amount,
//             // is_live: item.is_live,
//         });
//         setOpenModal(true);
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prev) => ({ ...prev, [name]: value }));
//     };

//     const handleUpdate = async () => {
//         if (!selectedItem) return;
//         setLoading(true);

//         try {
//             const response = await axios.put(
//                 `https://api.medstown.com/offer/entities/${selectedItem._id}`,
//                 {
//                     title: formData.title,
//                     // discount_type: formData.discount_type,
//                     // discount: formData.discount,
//                     // minimum_bill_amount: formData.minimum_bill_amount,
//                     // is_live: formData.is_live,
//                 },
//                 {
//                     headers: { "Content-Type": "application/json" },
//                 }
//             );

//             fetchData(currentPage);
//             // window.location.reload();
//             setOpenModal(false);
//         } catch (error) {
//             console.error("Error updating data:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleStatusToggle = async (item, key, page, query) => {
//         try {
//             const updatedStatus = !item[key];
//             const payload = {
//                 [key]: updatedStatus,
//             };
//             if (key === "is_live" && !updatedStatus) {
//                 payload.isDeleted = true; // ✅ Add this!
//             }
//             await axios.delete(
//                 `https://api.medstown.com/offer/entities/${item._id}`,
//                 payload,
//                 {
//                     headers: { "Content-Type": "application/json" },
//                 }

//             ).then((data) => {

//                 if (data?.data?.success === true) {
//                     fetchData(currentPage)
//                     // fetchData()
//                     // const { data } =  axios.get(
//                     //     `https://api.medstown.com/offer/entities?page=${page}&slug=${query}`
//                     // );
//                     // console.log(data.data)
//                     // setData(data?.data);
//                     // setTotalPages(Math.ceil(data.data.totalPromocodes / 10));
//                 }
//             });

//             setData((prevData) =>
//                 prevData.map((d) =>
//                     d._id === item._id ? { ...d, [key]: updatedStatus } : d
//                 )
//             );
//             if (key === "is_live" && !updatedStatus) {
//                 setData((prevData) =>
//                     prevData.map((d) =>
//                         d._id === item._id ? { ...d, isDeleted: true } : d
//                     )
//                 );
//             }
//         } catch (error) {
//             console.error("Error updating status:", error);
//         }
//     };

//     const handleSearch = (e) => {
//         setSearchQuery(e.target.value);
//     };
//     return (
//         <>
//             <Stack
//                 direction="row"
//                 justifyContent="space-between"
//                 alignItems="center"
//                 mt={2}
//             >
//                 <TextField
//                     variant="outlined"
//                     size="small"
//                     placeholder="Search Coupon code..."
//                     value={searchQuery}
//                     onChange={handleSearch}
//                     sx={{ width: 300 }}
//                 />

//                 <Button
//                     variant="contained"
//                     color="primary"
//                     onClick={() => {
//                         setOpenModel2(true)

//                     }}
//                     sx={{
//                         borderRadius: "4px",
//                         fontSize: "14px",
//                     }}
//                 >
//                     Create Entities
//                 </Button>
//             </Stack>
//             <Card sx={{ marginTop: 4, py: 2 }}>
//                 <TableContainer>
//                     <Table>
//                         <TableHead>
//                             <TableRow>
//                                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                                     Entity id
//                                 </TableCell>
//                                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                                     Title
//                                 </TableCell>
//                                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                                     Description
//                                 </TableCell>
//                                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                                     Created At
//                                 </TableCell>
//                                 {/* <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                                     Discount
//                                 </TableCell>
//                                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                                     Min Bill Amount
//                                 </TableCell> */}
//                                 {/* <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                                     {" "}
//                                     Valid Until
//                                 </TableCell> */}
//                                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                                     Status
//                                 </TableCell>
//                                 {/* <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                                     Show On App
//                                 </TableCell> */}

//                                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
//                                     Action
//                                 </TableCell>
//                             </TableRow>
//                         </TableHead>

//                         <TableBody>
//                             {loading ? (
//                                 <TableRow>
//                                     <TableCell colSpan={7} align="center">
//                                         <Box display="flex" justifyContent="center" py={2}>
//                                             <CircularProgress />
//                                         </Box>
//                                     </TableCell>
//                                 </TableRow>
//                             ) : (
//                                 data.map((item) => (
//                                     <TableRow key={item._id}>
//                                         <TableCell>{item.entity_id}</TableCell>
//                                         <TableCell
//                                             sx={{
//                                                 maxWidth: 200,
//                                                 whiteSpace: "nowrap",
//                                                 overflow: "hidden",
//                                                 textOverflow: "ellipsis",
//                                             }}
//                                         >
//                                             {item.title}
//                                         </TableCell>
//                                         <TableCell
//                                             sx={{
//                                                 maxWidth: 200,
//                                                 whiteSpace: "nowrap",
//                                                 overflow: "hidden",
//                                                 textOverflow: "ellipsis",
//                                             }}
//                                         >
//                                             {item.description}
//                                         </TableCell>
//                                         <TableCell>{dayjs(item.createdAt).format("DD MMM YYYY, hh:mm A")}</TableCell>

//                                         <TableCell>
//                                             <Switch
//                                                 checked={!item.isDeleted}
//                                                 onChange={() => handleStatusToggle(item, "is_live")}
//                                                 color="default"
//                                                 sx={{
//                                                     "& .MuiSwitch-switchBase.Mui-checked": {
//                                                         color: "green",
//                                                     },
//                                                     "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
//                                                     {
//                                                         backgroundColor: "green",
//                                                     },
//                                                     "& .MuiSwitch-track": {
//                                                         backgroundColor: "gray",
//                                                     },
//                                                 }}
//                                             />
//                                         </TableCell>
//                                         {/* <TableCell>
//                                             <Switch
//                                                 checked={item.is_public}
//                                                 onChange={() => handleStatusToggle(item, "is_public")}
//                                                 color="default"
//                                                 sx={{
//                                                     "& .MuiSwitch-switchBase.Mui-checked": {
//                                                         color: "green",
//                                                     },
//                                                     "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
//                                                     {
//                                                         backgroundColor: "green",
//                                                     },
//                                                     "& .MuiSwitch-track": {
//                                                         backgroundColor: "gray",
//                                                     },
//                                                 }}
//                                             />
//                                         </TableCell> */}
//                                         <TableCell>
//                                             <Stack direction="row" spacing={1}>
//                                                 {/* Edit Button */}
//                                                 <IconButton
//                                                     onClick={() => handleEdit(item)}
//                                                     color="primary"
//                                                 >
//                                                     <MdEdit size={20} />
//                                                 </IconButton>

//                                                 {/* View Button */}
//                                                 <IconButton
//                                                     onClick={() =>
//                                                         navigate(`/admin/entity-list/${item._id}`)
//                                                     }
//                                                     color="secondary"
//                                                 >
//                                                     <MdVisibility size={20} />
//                                                 </IconButton>
//                                             </Stack>
//                                         </TableCell>
//                                     </TableRow>
//                                 ))
//                             )}
//                         </TableBody>
//                     </Table>
//                 </TableContainer>

//                 {/* Pagination */}
//                 <Pagination
//                     count={totalPages}
//                     page={currentPage}
//                     onChange={handlePageChange}
//                     sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}
//                 />

//                 {/* Edit Modal */}
//                 <Dialog open={openModal} onClose={() => setOpenModal(false)}>
//                     <DialogTitle>Edit Entity</DialogTitle>
//                     <DialogContent>
//                         <TextField
//                             margin="dense"
//                             label="Title"
//                             name="title"
//                             fullWidth
//                             value={formData.title}
//                             onChange={handleInputChange}
//                         />
//                         {/* <TextField
//                             margin="dense"
//                             label="Discount Type"
//                             name="discount_type"
//                             fullWidth
//                             value={formData.discount_type}
//                             onChange={handleInputChange}
//                         />
//                         <TextField
//                             margin="dense"
//                             label="Discount Value"
//                             name="discount"
//                             type="number"
//                             fullWidth
//                             value={formData.discount}
//                             onChange={handleInputChange}
//                         />
//                         <TextField
//                             margin="dense"
//                             label="Minimum Bill Amount"
//                             name="minimum_bill_amount"
//                             type="number"
//                             fullWidth
//                             value={formData.minimum_bill_amount}
//                             onChange={handleInputChange}
//                         /> */}
//                     </DialogContent>
//                     <DialogActions>
//                         <Button onClick={() => setOpenModal(false)}>Cancel</Button>
//                         <Button onClick={handleUpdate} color="primary">
//                             {loading ? <CircularProgress size={20} /> : "Update"}
//                         </Button>
//                     </DialogActions>
//                 </Dialog>
//             </Card>
//             {/* Modal Open */}
//             <Modal
//                 open={openModel2}
//                 onClose={() => setOpenModel2(false)}
//                 aria-labelledby="modal-modal-title"
//                 aria-describedby="modal-modal-description"
//             >
//                 <Box sx={style}>
//                     <EntitiesForm setOpenModel2={setOpenModel2}   fetchData = {fetchData} currentPage={currentPage} />
//                 </Box>
//             </Modal>
//         </>
//     );
// };
// const style = {
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: '40%',
//     bgcolor: 'background.paper',
//     borderRadius: '10px',
//     // border: '2px solid #000',
//     // boxShadow: 24,
//     p: 4,
// };
// export default Entities;




import React, { useState, useEffect, useCallback } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Card,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  CircularProgress,
  Box,
  Stack,
  IconButton,
  Modal,
  Tooltip,
  Typography,
  alpha,
  useTheme,
  Switch
} from "@mui/material";
import { MdEdit, MdVisibility } from "react-icons/md";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import debounce from "lodash.debounce";
import EntitiesForm from "./ModelForm/EntitiesForm";
import dayjs from "dayjs";

const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "60%", md: "40%" },
  bgcolor: "background.paper",
  borderRadius: 2,
  p: 4,
  boxShadow: 24,
};

const Entities = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const medstownColors = {
    primary: "#014D4D",
    secondary: "#02A0A0",
    accent: "#FFB800",
    success: "#4caf50",
    error: "#f44336",
    white: "#fff",
  };

  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [formData, setFormData] = useState({
    title: "",
  });

  // Fetch data with debounce to reduce API calls during search
  const fetchData = useCallback(
    debounce(async (page, query) => {
      setLoading(true);
      try {
        const url = query
          ? `https://api.medstown.com/offer/entities?page=${page}&slug=${query}`
          : `https://api.medstown.com/offer/entities?page=${page}`;
        const res = await axios.get(url);
        if (res.status === 200) {
          setData(res.data.data || []);
          setTotalPages(Math.ceil(res.data.totalPromocodes / 10));
        }
      } catch (err) {
        console.error("Failed to fetch data:", err);
      } finally {
        setLoading(false);
      }
    }, 500),
    []
  );

  useEffect(() => {
    fetchData(currentPage, searchQuery);
  }, [currentPage, searchQuery, fetchData]);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    setFormData({ title: item.title || "" });
    setOpenEditModal(true);
  };

  const handleInputChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleUpdate = async () => {
    if (!selectedItem) return;
    setLoading(true);
    try {
      await axios.put(
        `https://api.medstown.com/offer/entities/${selectedItem._id}`,
        { title: formData.title },
        { headers: { "Content-Type": "application/json" } }
      );
      fetchData(currentPage, searchQuery);
      setOpenEditModal(false);
      setSelectedItem(null);
    } catch (err) {
      console.error("Failed to update entity:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusToggle = async (item) => {
    setLoading(true);
    try {
      const updatedStatus = !item.is_live;
      const payload = {
        is_live: updatedStatus,
      };
      if (!updatedStatus) {
        payload.isDeleted = true;
      }
      await axios.delete(
        `https://api.medstown.com/offer/entities/${item._id}`,
        { data: payload, headers: { "Content-Type": "application/json" } }
      );
      setData((prev) =>
        prev.map((d) =>
          d._id === item._id ? { ...d, is_live: updatedStatus, isDeleted: updatedStatus ? false : true } : d
        )
      );
    } catch (err) {
      console.error("Failed to toggle status:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Header */}
      <Paper
        elevation={6}
        sx={{
          p: 3,
          mb: 3,
          borderRadius: 3,
          background: `linear-gradient(135deg, ${medstownColors.primary}, ${medstownColors.secondary})`,
          color: medstownColors.white,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Typography variant="h5" fontWeight="900" sx={{ letterSpacing: "-0.05em" }}>
          Entities Management
        </Typography>
        <Button
          variant="contained"
          onClick={() => setOpenCreateModal(true)}
          sx={{
            borderRadius: 2,
            fontSize: 14,
            backgroundColor: medstownColors.accent,
            color: medstownColors.primary,
            '&:hover': { backgroundColor: alpha(medstownColors.accent, 0.85) }
          }}
        >
          Create Entity
        </Button>
      </Paper>

      {/* Search & Controls */}
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="space-between" alignItems="center" mb={2}>
        <TextField
          value={searchQuery}
          onChange={handleSearchChange}
          label="Search entities"
          variant="outlined"
          size="small"
          sx={{ maxWidth: 400, width: "100%" }}
        />
      </Stack>

      {/* Table */}
      <Card>
        <TableContainer component={Paper} sx={{ maxHeight: 540 }}>
          <Table stickyHeader size="small" aria-label="entities table" sx={{ borderCollapse: "separate", borderSpacing: "0 8px" }}>
            <TableHead sx={{ backgroundColor: alpha(medstownColors.primary, 0.1) }}>
              <TableRow>
                {[
                  "Entity ID",
                  "Title",
                  "Description",
                  "Created At",
                  "Status",
                  "Actions",
                ].map((head) => (
                  <TableCell
                    key={head}
                    sx={{
                      fontWeight: 700,
                      fontSize: 13,
                      color: medstownColors.primary,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      whiteSpace: "nowrap",
                      px: 2,
                      py: 1,
                      borderBottom: "none",
                    }}
                  >
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {loading && data.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : data.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 6, fontStyle: "italic", color: "text.secondary" }}>
                    No records found.
                  </TableCell>
                </TableRow>
              ) : (
                data.map((item) => (
                  <TableRow
                    key={item._id}
                    hover
                    sx={{
                      bgcolor: "background.paper",
                      borderRadius: 2,
                      "&:hover": {
                        boxShadow: `0 4px 12px ${alpha(medstownColors.primary, 0.15)}`,
                        transform: "translateY(-2px)",
                      },
                      cursor: "pointer",
                    }}
                  >
                    <TableCell sx={{ px: 2 }}>{item.entity_id}</TableCell>
                    <TableCell sx={{ px: 2, maxWidth: 150, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.title}</TableCell>
                    <TableCell sx={{ px: 2, maxWidth: 250, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.description}</TableCell>
                    <TableCell sx={{ px: 2 }}>{dayjs(item.createdAt).format("DD MMM YYYY, hh:mm A")}</TableCell>
                    <TableCell sx={{ px: 2 }}>
                      <Switch
                        checked={!item.isDeleted}
                        onChange={() => handleStatusToggle(item)}
                        color="success"
                        size="small"
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: medstownColors.success,
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: alpha(medstownColors.success, 0.5),
                          },
                          "& .MuiSwitch-track": {
                            backgroundColor: alpha("#999", 0.3),
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell sx={{ px: 2 }}>
                      <Stack direction="row" spacing={1} justifyContent="center">
                        <Tooltip title="Edit">
                          <IconButton size="small" color="primary" onClick={() => handleEditClick(item)}>
                            <MdEdit />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="View">
                          <IconButton size="small" color="secondary" onClick={() => navigate(`/admin/entity-list/${item._id}`)}>
                            <MdVisibility />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Stack direction="row" justifyContent="center" spacing={2} mt={2}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
            size="small"
            siblingCount={0}
            boundaryCount={1}
          />
        </Stack>
      </Card>

      {/* Edit Modal */}
      <Dialog open={openEditModal} onClose={() => setOpenEditModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Entity</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Title"
            name="title"
            fullWidth
            value={formData.title}
            onChange={handleInputChange}
            size="small"
          />
          {/* You can add additional editable fields here */}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditModal(false)}>Cancel</Button>
          <Button onClick={handleUpdate} color="primary" disabled={loading}>
            {loading ? <CircularProgress size={20} /> : "Update"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Create Entity Modal */}
      <Modal open={openCreateModal} onClose={() => setOpenCreateModal(false)}>
        <Box sx={styleModal}>
          <EntitiesForm setOpenCreateModal={setOpenCreateModal} fetchData={fetchData} currentPage={currentPage} />
        </Box>
      </Modal>
    </>
  );
};

export default Entities;
